import { render, staticRenderFns } from "./OTPLoginCpn.vue?vue&type=template&id=53a5d2b8&scoped=true"
import script from "./OTPLoginCpn.vue?vue&type=script&lang=js"
export * from "./OTPLoginCpn.vue?vue&type=script&lang=js"
import style0 from "./OTPLoginCpn.vue?vue&type=style&index=0&id=53a5d2b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a5d2b8",
  null
  
)

export default component.exports